import React from 'react';

export default () => {
    return <img
        alt="medal"
        src="/static/images/icons/medal.svg"
        style={{ width: '22px', height: '22px' }}
    />
}
